import UserDetails from '@/pages/Users/UserDetails';
import { createLazyFileRoute } from '@tanstack/react-router';

export const Route = createLazyFileRoute('/users/$userId')({
  component: UserDetails,
});
